import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createRoot } from 'react-dom/client';

import './main.css';
import App from './components/App';

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);
